import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { Pill } from '@/ui';
import DualTime from '@/ui/components/DualTime';
import Heading from '@/ui/components/Heading';

import './styles.css';
import type { Props } from './types';

const EncounterCharts = ({ charts, showTitle = true }: Props) => (
  <div className={showTitle ? 'mt-4 border-t pt-2 border-y-gray-200 border-solid' : undefined}>
    {showTitle && <Heading value={3} text="Charts" />}
    {/* Shown when empty too, so a missing chart reads as missing rather than hidden. */}
    {charts.length === 0 ? (
      <Pill color="destructive" size="sm">
        None
      </Pill>
    ) : (
      <ul className="divide-y divide-gray-100">
        {charts.map((chart) => (
          <li key={chart.id} className={showTitle ? 'py-2' : 'py-2 first:pt-0'}>
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-medium">{chart.healthie_name || 'Untitled chart'}</span>
              {chart.is_billing_chart && (
                <Pill color="primary" size="sm">
                  Billing chart
                </Pill>
              )}
              <Pill color={chart.is_locked ? 'neutral' : 'warning'} size="sm">
                {chart.is_locked ? 'Locked' : 'Unlocked'}
              </Pill>
              <Pill variant="outline" color="neutral" size="sm">
                {chart.directly_linked ? 'Linked by appointment' : 'Linked by time range'}
              </Pill>
            </div>
            <p className="text-sm leading-5 text-gray-500">
              {chart.filled_by && `Filled by ${chart.filled_by}`}
              {chart.healthie_created_at && (
                <>
                  {' on '}
                  <DualTime dateTime={new Date(chart.healthie_created_at)} />
                </>
              )}
              {chart.locked_by && ` · Locked by ${chart.locked_by}`}
            </p>
            <div className="flex gap-4 text-sm">
              <a
                href={chart.external_links.homebase.url}
                className="text-blue-600"
                target="_blank"
                rel="noreferrer">
                Homebase form
                <FontAwesomeIcon className="ml-1" icon={faExternalLink} />
              </a>
              {chart.external_links.healthie.url && (
                <a
                  href={chart.external_links.healthie.url}
                  className="text-blue-600"
                  target="_blank"
                  rel="noreferrer">
                  Healthie #{chart.healthie_id}
                  <FontAwesomeIcon className="ml-1" icon={faExternalLink} />
                </a>
              )}
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default React.memo(EncounterCharts);
